import React, {useContext, useEffect} from 'react'
import UserContext from '../context/UserContext'



function Logout(props) {

    const userCtx = useContext(UserContext)

    useEffect(() => {
        if (props.doLogout) {
            // !!! important - call onLoggedOut to reset property props.doLogout to false - otherwise it stays true and automatically logges me out on next login
            props.onLoggedOut()
            // console.log("Logout.jsx - cleaning up session")
 
            // navigate('/')
            try {
                userCtx.Logout()
            }
            catch (e) {
                console.log("error", e)
            }
        }
    }, [props.doLogout])
    

    return (
        <></>
    )
}

export default Logout
